/**
 * The name a new, unnamed document type starts with: "Document type N", N the lowest number no
 * type in the job already uses (names compared trimmed, ignoring case).
 *
 * Counting the types instead ("Document type " + count + 1) repeated a name after a removal: with
 * "Document type 1" removed, the next new type was named "Document type 2" beside an existing
 * one, and filing matches types by name.
 */
export function nextDocumentTypeName(types: readonly { name: string }[]): string {
  const taken = new Set(types.map((type) => type.name.trim().toLocaleLowerCase()));
  let number = 1;
  while (taken.has(`document type ${number}`)) number++;
  return `Document type ${number}`;
}
